import { Font, StyleSheet } from '@react-pdf/renderer';

import MarkaziBold from '/assets/fonts/MarkaziText-Bold.ttf?url';
import MarkaziMedium from '/assets/fonts/MarkaziText-Medium.ttf?url';
import MarkaziRegular from '/assets/fonts/MarkaziText-Regular.ttf?url';
import MarkaziSemibold from '/assets/fonts/MarkaziText-SemiBold.ttf?url';

Font.register({
	family: 'Markazi',
	fonts: [
		{ src: MarkaziRegular, fontWeight: 400 },
		{ src: MarkaziMedium, fontWeight: 500 },
		{ src: MarkaziSemibold, fontWeight: 600 },
		{ src: MarkaziBold, fontWeight: 700 }
	]
});

Font.registerHyphenationCallback((word) => {
	const SPLIT_HYPENS_SIZE = 20;
	if (word?.length > SPLIT_HYPENS_SIZE) {
		const splitWord = [];
		for (let i = 0; i < word.length; i += SPLIT_HYPENS_SIZE) {
			splitWord.push(word.substring(i, i + SPLIT_HYPENS_SIZE));
		}
		return splitWord;
	} else {
		return [word];
	}
});

const styles = StyleSheet.create({
	container: {},
	text: {
		fontFamily: 'Markazi'
	},
	textArabic: {
		fontFamily: 'Markazi',
		textAlign: 'right'
	},
	textColor: {
		color: '#000'
	},
	textColorSecondary: {
		color: '#383838'
	},
	textWhite: {
		color: '#fff'
	},
	textCenter: {
		textAlign: 'center'
	},
	bgColor: {
		backgroundColor: '#383838'
	},
	textRegular: {
		fontWeight: 400
	},
	textMedium: {
		fontWeight: 500
	},
	textSemiBold: {
		fontWeight: 600
	},
	textBold: {
		fontWeight: 700
	},
	center: {
		justifyContent: 'center',
		alignItems: 'center'
	},
	table: {
		width: '100%',
		display: 'flex',
		flexDirection: 'column',
		marginBottom: 0
	},
	w25: {
		width: '25%'
	},
	w33: {
		width: '33.333%'
	},
	w50: {
		width: '50%'
	},
	w66: {
		width: '66.666%'
	},
	w75: {
		width: '75%'
	},
	w100: {
		width: '100%'
	},
	row: {
		display: 'flex',
		flexDirection: 'row'
	},

	/* =============================================
	=            Section Margin block            =
	=============================================*/
	ms1: {
		marginLeft: 5
	},
	ms2: {
		marginLeft: 10
	},
	ms3: {
		marginLeft: 15
	},
	me1: {
		marginRight: 5
	},
	me2: {
		marginRight: 10
	},
	me3: {
		marginRight: 15
	},
	mb1: {
		marginBottom: 5
	},
	mb2: {
		marginBottom: 10
	},
	mb3: {
		marginBottom: 15
	},
	mt1: {
		marginTop: 5
	},
	mt2: {
		marginTop: 10
	},
	mt3: {
		marginTop: 15
	} /* =====  End of Section Margin block  ======*/,
	column: {
		display: 'flex',
		flexDirection: 'column'
	},
	wrap: {
		flexWrap: 'wrap'
	},
	tableRow: {
		display: 'flex',
		flexDirection: 'row',
		paddingHorizontal: 5
	},
	flexEnd: {
		justifyContent: 'flex-end'
	},
	section: {
		borderRadius: 5,
		padding: 8,
		display: 'flex',
		flexDirection: 'row',
		marginBottom: 15
	},
	border: {
		borderWidth: 1,
		borderColor: '#ccc'
	},
	borderVertical: {
		borderLeftWidth: 1,
		borderRightWidth: 1,
		borderColor: '#ccc'
	},
	borderHorizontal: {
		borderTopWidth: 1,
		borderBottomWidth: 1,
		borderColor: '#ccc'
	},
	borderBottom: {
		borderBottomWidth: 1,
		borderBottomColor: '#ccc'
	}
});

export default styles;
